"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SecureYourEngagement() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="secure-engagement" ref={ref} className="py-16 md:py-20 bg-[#0d1b2a] bg-linear-to-b from-[#060f1a] to-[#0d1b2a]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className={`
            relative overflow-hidden rounded-[2.5rem] bg-[#112234] border-t-2 border-t-[rgb(0,196,180)] p-10 md:p-20 text-center
            transition-all duration-700 ease-out shadow-sm hover:shadow-md
            ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}
          `}>
          
          <div className="absolute -top-24 -right-24 w-96 h-96 bg-[rgb(0,196,180)]/5 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-[rgb(0,196,180)]/5 rounded-full blur-3xl pointer-events-none" />

          <div className="relative z-10 max-w-2xl mx-auto">
            <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-white mb-4">
              Secure Your Engagement
            </h2>
            <p className="text-lg text-white/70 mb-8 leading-relaxed">
              Experience Auckland's leading boutique consultancy. Milestone-based delivery with senior-level expertise. No retainers, no surprises—just outcome-focused results.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Button size="lg" className="w-full sm:w-auto h-12 rounded-full px-8 text-base font-medium transition-all hover:scale-[1.02] active:scale-[0.98] group bg-[rgb(0,196,180)] text-white hover:bg-[rgb(0,196,180)]/90 border-none" asChild>
                <Link to="/ContactPage">
                  Start Your Project
                  <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1 text-[rgb(0,196,180)]" />
                </Link>
              </Button>
              <Button variant="outline" size="lg" className="w-full sm:w-auto h-12 rounded-full px-8 text-base font-medium transition-all bg-transparent border-[rgb(0,196,180)] text-[rgb(0,196,180)] hover:bg-[rgb(0,196,180)]/10 hover:text-[rgb(0,196,180)]" asChild>
                <Link to="/ServicesPage">
                  View Services
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}